<template>
  <div class="partner-resumes-base-resumes-row__candidate">
    <picture v-if="resume.avatar"
             class="partner-resumes-base-resumes-row__candidate-img">
      <img :src="resume.avatar"
           alt="User"/>
    </picture>
    <div v-else
         :style="{backgroundColor: resume.color}"
         class="partner-resumes-base-resumes-row__candidate-img  _placeholder">
      {{ getAbbr(resume.lastname, resume.firstname) }}
    </div>
    <div class="partner-resumes-base-resumes-row__candidate-name">
      {{ resume.fullname }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'APResumesBaseResumePageRowCandidate',
    props: {
      resume: Object
    },
    methods: {
      getAbbr(first, second) {
        return (first && first[0] || '-') + (second && second[0] || '-')
      }
    }
  }
</script>

<style lang="less">

</style>
